import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchBatchItemDetail } from '../api/importService';
/**
 * Hook for fetching full detail of a specific import batch item.
 */
var useImportBatchItemDetail = function (batchId, itemId) {
    var ky = useOkapiKy();
    var _a = useQuery(['czna-import-batch-item-detail', batchId, itemId], function () { return fetchBatchItemDetail(ky, batchId, itemId); }, { enabled: !!batchId && !!itemId }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    return {
        data: data !== null && data !== void 0 ? data : null,
        isLoading: isLoading,
        isError: isError,
        error: error,
    };
};
export default useImportBatchItemDetail;
